import React, { useContext } from 'react';
import { RouteErrorType } from '@teliaee/crm-components';
import { RootStoreContext } from '../stores/RootStore';
import { Anchor, Button, Container, Grid, GridColumn, List, ListItem, Notice, Separator } from 'telia-front-react';
import { createGaEvent } from '../util/GaUtil';
import { observer } from 'mobx-react';
import { addLanguageSlugToUrl } from '../util/PathUtil';
import config from '../Config';
export const ValidationFallback = (props) => {
    const { ssoStore } = useContext(RootStoreContext);
    const { errors } = props;
    if (!ssoStore.loggedIn && ssoStore.isDealer) {
        return React.createElement(LoginRequiredNotice, null);
    }
    if (errors.find((error) => error.type === RouteErrorType.AUTH_LEVEL) && !ssoStore.isDealer) {
        return ssoStore.loggedIn ? React.createElement(HardAuthRequiredNotice, null) : React.createElement(LoginRequiredNotice, null);
    }
    if (errors.find((error) => error.type === RouteErrorType.REPRESENTATIVE && error.text.includes('brand specific or legal mandate'))) {
        return React.createElement(DiilMandateRequiredNotice, null);
    }
    if (errors.find((error) => error.type === RouteErrorType.REPRESENTATIVE)) {
        return React.createElement(RepresentativeRequiredNotice, null);
    }
    if (errors.find((error) => error.type === RouteErrorType.CUSTOMER_TYPE)) {
        return React.createElement(PrivateCustomerRequiredNotice, null);
    }
    return React.createElement(NotFound, null);
};
const HardAuthRequiredNotice = () => {
    const { translateStore: { translate }, ssoStore } = useContext(RootStoreContext);
    return (React.createElement(Container, null,
        React.createElement(Notice, { align: "center" },
            React.createElement(Grid, { align: ['between-xs', 'middle-xs'], noWrap: ['sm'] },
                React.createElement(GridColumn, { width: ['xs', 'max-sm'] },
                    React.createElement("p", null, translate('notice.logInWithHardAuth'))),
                React.createElement(GridColumn, { width: ['xs', 'min-sm'] },
                    React.createElement(Button, { id: "front-page-notice-navigate", text: translate('notice.logInWithHardAuth.button.text'), variant: "secondary", iconRight: "#arrow-right", onClick: () => ssoStore.openSsoFrame() })))),
        React.createElement(Separator, { color: "invisible", spacing: "small" })));
};
export const LoginRequiredNotice = () => {
    const { translateStore: { translate }, ssoStore } = useContext(RootStoreContext);
    return (React.createElement(Container, null,
        React.createElement(Notice, { align: "center" },
            React.createElement(Grid, { align: ['between-xs', 'middle-xs'] },
                React.createElement(GridColumn, { width: ['xs'] }, translate('auth.notice')),
                React.createElement(GridColumn, { width: ['xs'] },
                    React.createElement(Button, { text: translate('auth.button'), iconRight: "#arrow-right", variant: "secondary", onClick: () => {
                            createGaEvent({ eventCategory: 'Iseteenindus', eventAction: 'Info nägemiseks logi iseteenindusse', eventLabel: 'Sisene iseteenindusse' });
                            ssoStore.openSsoFrame();
                        } })))),
        React.createElement(Separator, { spacing: "small", color: "invisible" })));
};
const RepresentativeRequiredNotice = observer(() => {
    const { ssoStore, translateStore } = useContext(RootStoreContext);
    return (React.createElement(Container, null,
        React.createElement(Notice, { align: "center" },
            React.createElement(Grid, { align: ['between-xs', 'middle-xs'], noWrap: ['sm'] },
                React.createElement(GridColumn, { width: ['xs', 'max-sm'] },
                    React.createElement("p", null, translateStore.translate('notice.chooseCustomer'))),
                React.createElement(GridColumn, { width: ['xs', 'min-sm'] }, !ssoStore.isDealer && (React.createElement(Button, { text: translateStore.translate('notice.choose'), variant: "secondary", iconRight: "#arrow-right", onClick: () => ssoStore.openSsoFrame() }))))),
        React.createElement(Separator, { color: "invisible", spacing: "small" })));
});
const DiilMandateRequiredNotice = () => {
    const { translateStore: { translate } } = useContext(RootStoreContext);
    return (React.createElement(Container, null,
        React.createElement(Notice, null, translate('customerNotice.diilMandateRequired')),
        React.createElement(Separator, { color: "invisible", spacing: "small" })));
};
const PrivateCustomerRequiredNotice = observer(() => {
    const { ssoStore, translateStore } = useContext(RootStoreContext);
    return (React.createElement(Container, null,
        React.createElement(Notice, { align: "center" },
            React.createElement(Grid, { align: ['between-xs', 'middle-xs'], noWrap: ['sm'] },
                React.createElement(GridColumn, { width: ['xs', 'max-sm'] },
                    React.createElement("p", null, translateStore.translate('notice.choosePrivateCustomer'))),
                React.createElement(GridColumn, { width: ['xs', 'min-sm'] }, !ssoStore.isDealer && (React.createElement(Button, { text: translateStore.translate('notice.choose'), variant: "secondary", iconRight: "#arrow-right", onClick: () => ssoStore.openSsoFrame() }))))),
        React.createElement(Separator, { color: "invisible", spacing: "small" })));
});
export const NotFound = () => {
    const { translateStore: { translate, currentLanguage } } = useContext(RootStoreContext);
    return (React.createElement(Container, null,
        React.createElement(Grid, { align: ['center-xs', 'middle-xs'] },
            React.createElement(GridColumn, { width: ['xs'] },
                React.createElement("img", { src: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", "data-srcset": "//res.cloudinary.com/telia/image/upload/c_scale,w_462,fl_lossy,f_auto,q_auto:best/diil/veeb/404/diil-raamatuga-valge2.gif 462w, //res.cloudinary.com/telia/image/upload/c_scale,w_925,fl_lossy,f_auto,q_auto:best/diil/veeb/404/diil-raamatuga-valge2.gif 925w", "data-sizes": "auto", className: "lazyload img-responsive center-block", width: "462", alt: "Fallback component image" })),
            React.createElement(GridColumn, { width: ['xs'] },
                React.createElement("div", { className: "text" },
                    React.createElement("h3", { className: "text__margin-double" }, translate('error.404.text')),
                    React.createElement("p", { className: "text__margin-double" }, translate('error.404.help')),
                    React.createElement(List, null,
                        React.createElement(ListItem, null,
                            React.createElement(Anchor, { url: addLanguageSlugToUrl(`${config.diilCrmUrl}/eteenindus`, currentLanguage) }, translate('error.404.selfservice'))),
                        React.createElement(ListItem, null,
                            React.createElement(Anchor, { url: "https://www.facebook.com/MobiilioperaatorDiil" }, translate('error.404.fb'))),
                        React.createElement(ListItem, null,
                            translate('error.404.callmail'),
                            React.createElement(Anchor, { url: "mailto:info@diil.ee" }, "info@diil.ee"))),
                    React.createElement("p", { className: "text__margin-double" },
                        React.createElement(Button, { text: translate('error.404.return'), url: "/" })))))));
};
